import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import GppGoodIcon from '@mui/icons-material/GppGood';
import { Section } from '../Section';
import { IconWrapper, InfoTypography } from './Seller.style';
import { colorPalette } from '../../../../../colorPalette';
export const SellerLegalInfo = ({ eshopLegalInfo, isCrew, legalMentions, partnership, siren, vat, form, capital, idu, email, }) => {
    var _a, _b, _c, _d, _e, _f;
    return (React.createElement(Section, null,
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(IconWrapper, null,
                React.createElement(GppGoodIcon, { sx: {
                        width: '16px',
                        height: '16px',
                        color: colorPalette.gray700,
                    } })),
            React.createElement(Typography, { sx: {
                    fontSize: '18px',
                    color: colorPalette.gray900,
                } }, legalMentions || 'Mentions légales')),
        isCrew ? (React.createElement(Box, { mt: 1 },
            React.createElement(InfoTypography, null, partnership ||
                `Cette boutique est le fruit d'un partenariat entre Rakuten et ${(eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.eshopName) || ''}. Ce partenariat permet au partenaire
            de diffuser les offres commerciales accessibles depuis son site ${(eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.crewDomain) || ''} directement sur Rakuten.`))) : (React.createElement(Box, null,
            React.createElement(Stack, { mt: 1, spacing: 0.5 },
                React.createElement(InfoTypography, null, eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.eshopName),
                React.createElement(InfoTypography, null, (_a = eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.address) === null || _a === void 0 ? void 0 : _a.address1),
                React.createElement(InfoTypography, null, (_b = eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.address) === null || _b === void 0 ? void 0 :
                    _b.zip,
                    " ", (_c = eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.address) === null || _c === void 0 ? void 0 :
                    _c.city),
                React.createElement(InfoTypography, null, (_d = eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.address) === null || _d === void 0 ? void 0 : _d.countryName)),
            React.createElement(Stack, { mt: 2, spacing: 1 },
                ((_e = eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.address) === null || _e === void 0 ? void 0 : _e.email) && React.createElement(InfoTypography, null,
                    email || 'Email:',
                    " ", (_f = eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.address) === null || _f === void 0 ? void 0 :
                    _f.email),
                React.createElement("br", null),
                (eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.companyNumber) && (React.createElement(InfoTypography, null,
                    siren || 'N° de SIREN:',
                    " ", eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 :
                    eshopLegalInfo.companyNumber)),
                (eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.companyVatNumber) && (React.createElement(InfoTypography, null,
                    vat || 'N° TVA intracommunautaire:',
                    " ", eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 :
                    eshopLegalInfo.companyVatNumber)),
                (eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.companyLegalStatus) && (React.createElement(InfoTypography, null,
                    form || 'Forme Juridique:',
                    " ", eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 :
                    eshopLegalInfo.companyLegalStatus)),
                (eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.companyRegisteredCapital) && (React.createElement(InfoTypography, null,
                    capital || 'Capital Social:',
                    " ", eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 :
                    eshopLegalInfo.companyRegisteredCapital,
                    ' '))))),
        (eshopLegalInfo === null || eshopLegalInfo === void 0 ? void 0 : eshopLegalInfo.companyIdentifiers) && (React.createElement(Stack, { direction: "row", spacing: 1, mt: 1 },
            React.createElement(InfoTypography, null,
                idu || 'IDU:',
                " "),
            React.createElement(Stack, { spacing: 0.5 }, eshopLegalInfo.companyIdentifiers.map((identifier, i) => {
                return React.createElement(InfoTypography, { key: i }, identifier);
            }))))));
};
